export default "__VITE_ASSET__DNBZDEKE__"